import SplitJobForm from './SplitJobForm.tsx';

interface SplitJob {
  id?: number;
  start_page?: number;
  end_page?: number;
  header_search_string?: string;
  split_rules?: string;
  status?: string;
  start_pages?: any;
  processing_job_id?: string;
}

interface Document {
  id: number;
  name: string;
  page_count?: number;
  split_jobs: SplitJob[];
}

interface SplitJobNewProps {
  document: Document;
  splitJob: SplitJob;
}

export default function SplitJobNew({ document, splitJob }: SplitJobNewProps) {
  return (
    <SplitJobForm 
      document={document}
      splitJob={splitJob}
    />
  );
}
